export enum recruitmentsApplicationTypes {
  FETCH_RECRUIMENTS_APPLICATION_REQUEST = "FETCH_RECRUIMENTS_APPLICATION_REQUEST",
  FETCH_RECRUIMENTS_APPLICATION_SUCCESS = "FETCH_RECRUIMENTS_APPLICATION_SUCCESS",
  FETCH_RECRUIMENTS_APPLICATION_FAILURE = "FETCH_RECRUIMENTS_APPLICATION_FAILURE",
}